var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ClaimEmailed',{attrs:{"header":"Rideshare - Claim Emailed","title":"Rideshare Insurance","subtitle":"Claim Sent","body":"A new rideshare claim has been sent on your behalf.","action":_vm.newClaim}})}
var staticRenderFns = []

export { render, staticRenderFns }